enum EContentType {
    
    DEFAULT         = 1,
    PAGE            = 2,
    CATEGORY        = 4,
    MENU_ITEM       = 8,
    SLIDER_ITEM     = 16,
    MAIN_PAGE_ITEM  = 32,
    STATISTIC_ITEM  = 64,
    SITE_SETTING    = 128,
    DATA            = 256,

    TENANT          = 512,
    TENANT_ITEM     = 1024,

    VENDOR          = 2048,
    STORE           = 4096,
    BRAND           = 8192,
    CATALOG_CATEGORY= 16384,
    PRODUCT         = 32768,
    PRODUCT_VARIANT = 65536,

    MAP             = 131072,
    SURVEY_ITEM     = 262144,
    MEDIA           = 524288

}

export default EContentType;
